module.exports = __webpack_public_path__ + "img/Training-Technologies.879efabe.png";